import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IS_EXPORT_ENV } from '../../../src/constants';
import Layout from '~/src/layout/_layout';
import Agent from '~/src/layout/agent';
import * as base from '~/src/helpers/basePageFunc';

class AgentPage extends Component {
    static propTypes = {
        city: PropTypes.object,
        hostname: PropTypes.string,
    };

    static async getInitialProps(options) {
        const { hostname } = await base.initialProps(options);
        let parseContent;
        return { hostname, parseContent };
    }

    render() {
        const { city, hostname } = this.props;
        const clientHostname = IS_EXPORT_ENV && process.browser ? document.location.hostname : hostname;
        return (
            <Layout
                title='Скачать приложение Мой Дом.ру для оплаты услуг на Android и iOS'
                description='Официальное приложение Мой Дом.ру - это личный кабинет в вашем телефоне. Удобно оплачивайте услуги и управляйте договором. Доступно для скачивания в App Store и Google Play.'
                hostname={clientHostname}
                withMenu={true}
                withFooter={true}
                withChat={true}
                relCanonical={`https://${clientHostname}/service/agent`}
            >
                <Agent city={ city }/>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity
});

export default connect(mapStateToProps)(AgentPage);
